(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');

    // click-directive to show the last appointments from user 
    module.directive('userLastAppointments', ['AppointmentDetailService', '$uibModalStack',
        function (AppointmentDetailService, $uibModalStack) {
            var directive = {
                link: link,
                restrict: 'A',
                scope: {
                    id: '@', // user id,
                    patientCaption: '@',     // patient caption (lastname firstname),
                    stopPropagation: '='
                }
            };
            return directive;

            function link(scope, element) {

                // click listener
                element.on('click', function (event) {
                    if (scope.stopPropagation) {
                        event.stopPropagation();
                    }
                    show();
                });

                // show
                function show() {
                    // close all possibly open modals
                    $uibModalStack.dismissAll();

                    // show modal with last appointments
                    AppointmentDetailService.historie(scope.id, scope.patientCaption);
                }


                // on destroy
                scope.$on("$destroy", function () {
                    element.off("click");
                });

            }
        }]);

})();